import React from "react";
import { useTranslation, Trans } from "react-i18next";

import Button from '../Button'

import book from '../../img/Trade/main.png'
import Fade from 'react-reveal/Fade'

function Main () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative rounded-b-[80px] xl:rounded-b-[200px] h-[827px] bg-[#F8F8F8]">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col items-center">
                <p className="merriweather font-[700] italic text-[32px] xl:text-[50px] mt-[40px] xl:mt-[56px] tex text-center xl:text-start">{t('trade.1')}</p>
                <p className="xl:max-w-[487px] inter text-center fdfd mt-[20px] xl:mt-[26px]"><Trans>{t('trade.2')}</Trans></p>
                <Button className={"mt-[40px] xl:mt-[26px]"}/>
                <div className="xl:w-[1220px] relative hidden xl:block">
                    <div className="absolute left-0 flex flex-col gap-[35px]">
                        <div className="flex flex-col gap-[10px]">
                            <p className="merriweather italic font-[700] text-[30px]">{t('trade.3')}</p>
                            <p className="inter font-[300] text-[16px] xl:max-w-[209px]">{t('trade.4')}</p>
                        </div>
                        <div className="flex flex-col gap-[10px]">
                            <p className="merriweather italic font-[700] text-[30px]">{t('trade.5')}</p>
                            <p className="inter font-[300] text-[16px] xl:max-w-[209px]">{t('trade.6')}</p>
                        </div>
                    </div>
                    <div className="absolute right-0 flex flex-col items-end gap-[35px]">
                        <div className="flex flex-col gap-[10px] items-end">
                            <p className="merriweather italic font-[700] text-[30px]">{t('trade.7')}</p>
                            <p className="inter font-[300] text-[16px] xl:max-w-[209px] xl:text-end">{t('trade.8')}</p>
                        </div>
                        <div className="flex flex-col gap-[10px] items-end">
                            <p className="merriweather italic font-[700] text-[30px]">{t('trade.9')}</p>
                            <p className="inter font-[300] text-[16px] xl:max-w-[224px] xl:text-end">{t('trade.10')}</p>
                        </div>
                    </div>
                </div>
                <div className="bg-main-circle w-[769px] h-[769px] rounded-full mt-[55px] circle-animation"></div>
                <Fade bottom delay={700}><img src={book} className="absolute bottom-0 w-[300px] xl:w-auto" alt="" /></Fade>
            </div>
        </div>
    );
}

export default Main;